import { render, staticRenderFns } from "./Signers.vue?vue&type=template&id=08f825d9"
import script from "./Signers.vue?vue&type=script&lang=js"
export * from "./Signers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports